"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StateReducer = exports.SetPageHeight = exports.Methods = exports.HandleScroll = exports.HandleResize = exports.CheckVisibility = void 0;
var _ExpandLess = _interopRequireDefault(require("@mui/icons-material/ExpandLess"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BackToTop = require("./BackToTop");
var _classnames = _interopRequireDefault(require("classnames"));
var _debounce = require("./../../utils/performance/debounce");
var _function = require("../../utils/type-checks/function");
var _number = require("../../utils/type-checks/number");
var _object = require("../../utils/type-checks/object");
var _scroll = require("./../../utils/scroll");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  CheckVisibility = (state, dispatch) => {
    const {
      isVisible,
      lastScrollY,
      minScroll
    } = state;
    let result;
    if (window.scrollY >= minScroll && !isVisible && window.scrollY <= lastScrollY) {
      result = true;
    } else if (window.scrollY < minScroll && isVisible || window.scrollY > lastScrollY) {
      result = false;
    } else {
      result = isVisible;
    }
    dispatch({
      type: "scrollUpdate",
      lastScrollY: window.scrollY,
      isVisible: result
    });
    return result;
  },
  HandleResize = (minScroll, triggerHeight, dispatch) => {
    const pageHeight = _BackToTop.Methods.SetPageHeight();
    let result = false;
    if ((0, _number.isNumber)(minScroll) && (0, _number.isNumber)(triggerHeight)) {
      result = true;
      dispatch({
        type: "resize",
        minScroll: minScroll,
        pageHeight: pageHeight,
        triggerHeight: triggerHeight
      });
    }
    return result;
  },
  HandleScroll = (e, state, dispatch) => {
    let result = false;
    if ((0, _object.isObject)(state) && (0, _function.isFunction)(dispatch)) {
      _BackToTop.Methods.CheckVisibility(state, dispatch);
    }
    if ((0, _object.isObject)(e) && (0, _function.isFunction)(e.preventDefault)) {
      e.preventDefault();
      result = true;
    }
    return result;
  },
  SetPageHeight = () => {
    return Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  },
  StateReducer = (state, action) => {
    let result = {
      ...state
    };
    if ((0, _object.isObject)(action)) {
      switch (action.type) {
        case "pageHeight":
          result = {
            ...state,
            pageHeight: action.pageHeight
          };
          break;
        case "resize":
          result = {
            ...state,
            isVisible: false,
            minScroll: action.minScroll,
            pageHeight: action.pageHeight,
            triggerHeight: action.triggerHeight
          };
          break;
        case "scrollUpdate":
          result = {
            ...state,
            isVisible: action.isVisible,
            lastScrollY: action.lastScrollY
          };
          break;
        default:
          result = state;
          break;
      }
    }
    return result;
  },
  Methods = exports.Methods = {
    CheckVisibility: CheckVisibility,
    HandleResize: HandleResize,
    HandleScroll: HandleScroll,
    SetPageHeight: SetPageHeight,
    StateReducer: StateReducer
  };

/**
 * Back to Top Button Control, included in the Footer Component
 *
 * @visibleName Back To Top
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.StateReducer = StateReducer;
exports.SetPageHeight = SetPageHeight;
exports.HandleScroll = HandleScroll;
exports.HandleResize = HandleResize;
exports.CheckVisibility = CheckVisibility;
const BackToTop = props => {
  const {
      className,
      customTheme = {},
      initialPageHeight,
      minScroll = () => window.innerHeight * 2,
      styles = {},
      testId,
      throttleAmount = 100,
      triggerHeight = () => window.innerHeight * 4,
      visible = false
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    initialState = {
      isVisible: visible,
      lastScrollY: window.scrollY,
      minScroll: (0, _function.isFunction)(minScroll) ? minScroll() : minScroll,
      pageHeight: (0, _number.isNumber)(initialPageHeight) ? initialPageHeight : _BackToTop.Methods.SetPageHeight(),
      throttleAmount: throttleAmount,
      triggerHeight: (0, _function.isFunction)(triggerHeight) ? triggerHeight() : triggerHeight
    },
    [state, dispatch] = (0, _react.useReducer)(_BackToTop.Methods.StateReducer, initialState),
    buttonStyles = merge({
      backgroundColor: theme.palette.primary.main,
      border: "0.2rem solid #FFFFFF",
      borderRadius: "0.5rem",
      boxShadow: "0 0 0.3rem 0.1rem rgba(0, 115, 176, 0)",
      height: "5rem",
      margin: "0",
      minHeight: "0",
      minWidth: "0",
      opacity: state.isVisible ? "1" : "0",
      padding: "0",
      position: "static",
      transition: "opacity 0.1s ease-in-out, scale 0.25s ease-in",
      width: "5rem",
      "@media (hover: none)": {
        "&:hover": {
          backgroundColor: theme.palette.primary.main
        }
      },
      "@media (hover: hover)": {
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
          transform: "scale(105%)"
        }
      },
      "&:active,&:focus-visible": {
        backgroundColor: theme.palette.primary.main,
        transform: "scale(105%)"
      },
      "svg": {
        fill: "#FFFFFF"
      }
    }, styles),
    handleResize = () => {
      const minScrollArg = (0, _function.isFunction)(minScroll) ? minScroll() : state.minScroll,
        triggerHeightArg = (0, _function.isFunction)(triggerHeight) ? triggerHeight() : state.triggerHeight;
      (0, _debounce.debounce)(_BackToTop.Methods.HandleResize(minScrollArg, triggerHeightArg, dispatch), state.throttleAmount);
    },
    compiledClasses = (0, _classnames.default)({
      "back-to-top": true,
      [`${className}`]: className
    }),
    handleScroll = (0, _react.useCallback)(e => {
      (0, _debounce.debounce)(_BackToTop.Methods.HandleScroll(e, state, dispatch), state.throttleAmount);
    }, [state]);
  (0, _react.useEffect)(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });
  (0, _react.useLayoutEffect)(() => {
    if (state.pageHeight >= state.triggerHeight) {
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, [handleScroll, state.pageHeight, state.triggerHeight]);
  (0, _react.useLayoutEffect)(() => {
    dispatch({
      type: "pageHeight",
      pageHeight: _BackToTop.Methods.SetPageHeight()
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: compiledClasses,
    sx: {
      display: state.isVisible ? "block" : "none",
      left: {
        xs: "calc(100vw - 7rem)",
        md: "calc(100vw - 9rem)"
      },
      position: "fixed",
      bottom: {
        xs: "2rem",
        md: "4rem"
      },
      zIndex: "980"
    },
    "data-testid": testId
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    "aria-label": "Back to Top",
    className: "back-to-top__button",
    "data-testid": testId ? `${testId}__button` : undefined,
    onClick: _scroll.scrollToTop,
    sx: buttonStyles
  }, /*#__PURE__*/_react.default.createElement(_ExpandLess.default, {
    alt: "Back to Top Button Icon",
    className: "back-to-top__button-icon"
  })));
};

// Define propTypes;
BackToTop.propTypes = {
  /** Custom class name(s) */
  className: _propTypes.default.string,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** @ignore */
  initialPageHeight: _propTypes.default.number,
  /** Amount of pixels to scroll before displaying control, or function to compute value (Default Value: () => window.innerHeight * 2) */
  minScroll: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.number]),
  /** Styles Override Object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Amount in milliseconds to throttle the onScroll method (Default Value: 100) */
  throttleAmount: _propTypes.default.number,
  /** Window pixel height that triggers behavior, or function to compute value (Default Value: () => window.innerHeight * 4) */
  triggerHeight: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.number]),
  /** Boolean to show control on load (Default Value: false) */
  visible: _propTypes.default.bool
};

// Export component as default;
var _default = exports.default = BackToTop;